import { Component, OnInit, Injectable, ViewContainerRef } from '@angular/core';
import { Toast, ToastsManager } from 'ng2-toastr';

@Injectable()
export class ToasterService {

    constructor(public toastr: ToastsManager) {
    }

    setRootViewContainerRef(vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef);
    }

    // you can override or add any options, positionClass is ignored (known ng-toastr bug)
    // tslint:disable-next-line: member-ordering
    options: any = {
        toastLife: 3000,
        enableHTML: true
    };

    info(title: string, message?: string): Promise<Toast> {
        return this.toastr.info(this.getContentHTML(title, message), null, this.options);
    }

    warning(title: string, message?: string): Promise<Toast> {
        return this.toastr.warning(this.getContentHTML(title, message), null, this.options);
    }

    error(title: string, message?: string): Promise<Toast> {
        return this.toastr.error(this.getContentHTML(title, message), null, this.options);
    }    

    success(title: string, message?: string): Promise<Toast> {
        return this.toastr.success(this.getContentHTML(title, message), null, this.options);
    }

    getContentHTML(title: string, message?: string): string {
        if (message) {
            return `<div class="toaster-content"><div class="toast-title">${title}</div><div><span class="toast-message">${message}</span></div></div></div>`;
        } else {
            return `<div class="toaster-content"><div class="toast-title">${title}</div></div></div>`;
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/services/toast/toast.service.ts